import { all, call, takeEvery, fork } from "redux-saga/effects";
import requestFunction from "../Utils/SagaGenericFunction";
import newRequestFunction from "../Utils/newSGF"

import {
  FETCH_ALL_PARTNERS,
  FETCH_PARTNER_BY_ID,
  FETCH_PARTNER_DASHBOARD_DETAILS,
  CREATE_PARTNER,
  ACTIVATE_PARTNER,
  DEACTIVATE_PARTNER,
  EDIT_PARTNER,
  EXPORT_PARTNER,
  PRINT_PARTNERS,
} from "../ActionTypes";

import {
  fetchAllPartnersSuccess,
  fetchAllPartnersFailure, 

  fetchPartnerByIdSuccess,
  fetchPartnerByIdFailure,
  fetchPartnerDashboardDetailsSuccess,
  
  createPartnerSuccess,
  createPartnerFailure,
  
  activatePartnerSuccess,
  deactivatePartnerSuccess,
  
  editPartnerSuccess,
  editPartnerFailure,
  
  exportPartnerSuccess,
  printPartnersSuccess,
} from "../Actions";

import {
  getAllPartners,
  getPartnerById, 
  getPartnersDashboardData,
  createPartner,  
  activatePartner,  
  deactivatePartner,  
  editPartner,  
  exportPartners, 
  getAllPartnersWithoutPagination,
} from "../Api"


// all requests
const getAllPartnersRequest = function* ({payload}) {
  yield call(newRequestFunction, fetchAllPartnersSuccess, fetchAllPartnersFailure, getAllPartners, payload)
}

const getPartnerbyIdRequest = function* ({payload}) {
  yield call(newRequestFunction, fetchPartnerByIdSuccess, fetchPartnerByIdFailure, getPartnerById, payload)
}

const getPartnerDashboardDataRequest = function* ({payload}) {
  yield call(requestFunction, fetchPartnerDashboardDetailsSuccess, getPartnersDashboardData, payload)
}

const createPartnerRequest = function* ({payload}) {
  yield call(newRequestFunction, createPartnerSuccess, createPartnerFailure, createPartner, payload)
}

const activatePartnerRequest = function* ({payload}) {
  yield call(requestFunction, activatePartnerSuccess, activatePartner, payload)
}

const deactivatePartnerRequest = function* ({payload}) {
  yield call(requestFunction, deactivatePartnerSuccess, deactivatePartner, payload)
}

const editPartnerRequest = function* ({payload}) {
  yield call(newRequestFunction, editPartnerSuccess, editPartnerFailure, editPartner, payload)
}

const exportPartnerRequest = function* ({payload}) {
  yield call(requestFunction, exportPartnerSuccess, exportPartners, payload)
}

const printPartnerRequest = function* ({payload}) {
  yield call(requestFunction, printPartnersSuccess, getAllPartnersWithoutPagination, payload)
}


// all watchers
export const getAllPartnersWatcher = function* () {
  yield takeEvery(FETCH_ALL_PARTNERS, getAllPartnersRequest);
}

export const getPartnerbyIdWatcher = function* () {
  yield takeEvery(FETCH_PARTNER_BY_ID, getPartnerbyIdRequest)
}

export const getPartnerDashboardDataWatcher = function* () {
  yield takeEvery(FETCH_PARTNER_DASHBOARD_DETAILS, getPartnerDashboardDataRequest)
}

export const createPartnerWatcher = function* () {
  yield takeEvery(CREATE_PARTNER, createPartnerRequest)
}

export const activatePartnerWatcher = function* () {
  yield takeEvery(ACTIVATE_PARTNER, activatePartnerRequest)
}

export const deactivatePartnerWatcher = function* () {
  yield takeEvery(DEACTIVATE_PARTNER, deactivatePartnerRequest)
}

export const editPartnerWatcher = function* () {
  yield takeEvery(EDIT_PARTNER, editPartnerRequest)
}

export const exportPartnerWatcher = function* () {
  yield takeEvery(EXPORT_PARTNER, exportPartnerRequest)
}

export const printPartnerWatcher = function* () {
  yield takeEvery(PRINT_PARTNERS, printPartnerRequest)
}

export default function* rootSaga() {
  yield all([
    fork(getAllPartnersWatcher),
    fork(getPartnerbyIdWatcher),
    fork(getPartnerDashboardDataWatcher),
    fork(createPartnerWatcher),
    fork(activatePartnerWatcher),
    fork(deactivatePartnerWatcher),
    fork(editPartnerWatcher),
    fork(exportPartnerWatcher),
    fork(printPartnerWatcher),
  ]);
}